const Categories = () => (
  <div>
    <button type="button">Status</button>
  </div>
);

export default Categories;
